import { assetsService } from '@mediabank/client';

const assetsServiceWrapper = {};

for (const [methodName, method] of Object.entries(assetsService)) {
    assetsServiceWrapper[methodName] = (...args) =>
        method(...args).catch(error => {
            console.error(`mediabank-next-transition error: ${methodName} service.`, error);

            if (error?.response?.status === 401) {
                window.location.href = '/logout';
            }

            return error.response;
        });
}

export default { ...assetsServiceWrapper };
